module.exports = __webpack_public_path__ + "img/logout.6e11a7ea.svg";